import { fillVariants } from "../../../styles/utils/fill"
import { classNames } from "../../../utils"
import type { IconProps } from "../../types"

// https://fonts.google.com/icons?selected=Material+Symbols+Outlined:bolt:FILL@0;wght@400;GRAD@0;opsz@24&icon.query=bolt
export const Bolt = ({
  size = 24,
  className,
  fill = "current",
  fillAttribute = "currentColor",
  ...rest
}: IconProps) => {
  return (
    <svg
      aria-label="Bolt"
      className={classNames(fillVariants({ fill }), className)}
      fill={fillAttribute}
      height={size}
      role="img"
      viewBox="0 -960 960 960"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="m422-232 207-248H469l29-227-185 267h139l-30 208ZM320-80l40-280H160l360-520h80l-40 320h240L400-80h-80Zm151-390Z" />
    </svg>
  )
}
